import { color } from './color';

export const scheme = {
    // Primary Palette

    StarRezBrandColors: {
        BlueRegular: {
            backgroundColor: color.StarRezBrandColors.Blue60,
            color: 'white',
        },
        WhiteRegular: {
            backgroundColor: color.StarRezBrandColors.WhiteSR,
            color: color.StarRezBrandColors.Grey80,
        },
        // tslint:disable-next-line: object-literal-sort-keys
        GreyDarker: {
            backgroundColor: color.StarRezBrandColors.Grey80,
            color: 'white',
        },
        GreyLighter: {
            backgroundColor: color.StarRezBrandColors.Grey30,
            color: color.StarRezBrandColors.Grey80,
        },
        YellowRegular: {
            backgroundColor: color.StarRezBrandColors.YellowSR,
            color: color.StarRezBrandColors.Grey80,
        },
    },

    Grey: {
        Darkest: {
            backgroundColor: color.Grey.G100,
            color: 'white',
        },
        UltraDark: {
            backgroundColor: color.Grey.G90,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Darker: {
            backgroundColor: color.Grey.G80,
            color: 'white',
        },
        Dark: {
            backgroundColor: color.Grey.G70,
            color: 'white',
        },
        RegularDark: {
            backgroundColor: color.Grey.G60,
            color: 'white',
        },
        RegularLight: {
            backgroundColor: color.Grey.G50,
            color: color.Grey.G80,
        },
        Light: {
            backgroundColor: color.Grey.G40,
            color: color.Grey.G80,
        },
        Lighter: {
            backgroundColor: color.Grey.G30,
            color: color.Grey.G80,
        },
        UltraLight: {
            backgroundColor: color.Grey.G20,
            color: color.Grey.G80,
        },
        Lightest: {
            backgroundColor: color.Grey.G10,
            color: color.Grey.G80,
        },
    },

    // Secondary Palette
    Blue: {
        Darker: {
            backgroundColor: color.Blue.B100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Blue.B80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Blue.B60,
            color: 'white',
        },
        Light: {
            backgroundColor: color.Blue.B40,
            color: color.Blue.B100,
        },
        Lighter: {
            backgroundColor: color.Blue.B20,
            color: color.Blue.B100,
        },
    },
    Green: {
        Darker: {
            backgroundColor: color.Green.G100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Green.G80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Green.G60,
            color: color.Green.G100,
        },
        Light: {
            backgroundColor: color.Green.G40,
            color: color.Green.G100,
        },
        Lighter: {
            backgroundColor: color.Green.G20,
            color: color.Green.G100,
        },
    },
    Orange: {
        Darker: {
            backgroundColor: color.Orange.O100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Orange.O80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Orange.O60,
            color: color.Orange.O100,
        },
        Light: {
            backgroundColor: color.Orange.O40,
            color: color.Orange.O100,
        },
        Lighter: {
            backgroundColor: color.Orange.O20,
            color: color.Orange.O100,
        },
    },
    Pink: {
        Darker: {
            backgroundColor: color.Pink.P100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Pink.P80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Pink.P60,
            color: 'white',
        },
        Light: {
            backgroundColor: color.Pink.P40,
            color: color.Pink.P100,
        },
        Lighter: {
            backgroundColor: color.Pink.P20,
            color: color.Pink.P100,
        },
    },
    Purple: {
        Darker: {
            backgroundColor: color.Purple.P100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Purple.P80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Purple.P60,
            color: 'white',
        },
        Light: {
            backgroundColor: color.Purple.P40,
            color: color.Purple.P100,
        },
        Lighter: {
            backgroundColor: color.Purple.P20,
            color: color.Grey.G80,
        },
    },
    Red: {
        Darker: {
            backgroundColor: color.Red.R100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Red.R80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Red.R60,
            color: 'white',
        },
        Light: {
            backgroundColor: color.Red.R40,
            color: color.Red.R100,
        },
        Lighter: {
            backgroundColor: color.Red.R20,
            color: color.Red.R100,
        },
    },
    Teal: {
        Darker: {
            backgroundColor: color.Teal.T100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Teal.T80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Teal.T60,
            color: color.Teal.T100,
        },
        Light: {
            backgroundColor: color.Teal.T40,
            color: color.Teal.T100,
        },
        Lighter: {
            backgroundColor: color.Teal.T20,
            color: color.Teal.T100,
        },
    },
    Yellow: {
        Darker: {
            backgroundColor: color.Yellow.Y100,
            color: 'white',
        },
        // tslint:disable-next-line: object-literal-sort-keys
        Dark: {
            backgroundColor: color.Yellow.Y80,
            color: 'white',
        },
        Regular: {
            backgroundColor: color.Yellow.Y60,
            color: color.Yellow.Y100,
        },
        Light: {
            backgroundColor: color.Yellow.Y40,
            color: color.Yellow.Y100,
        },
        Lighter: {
            backgroundColor: color.Yellow.Y20,
            color: color.Yellow.Y100,
        },
    },
};
